import { AxiosError } from "axios";
import { TimeEntryConflictItem } from "@myapp/contract";

export function parseCompletedBlockersFromError(error: unknown): TimeEntryConflictItem[] | null {
  if (!(error instanceof AxiosError)) return null;
  if (error.response?.status !== 409) return null;
  const data = error.response.data as { error?: string; data?: unknown };
  if (data?.error !== "TIME_ENTRY_COMPLETED_BLOCKERS") return null;
  if (!Array.isArray(data?.data)) return null;
  return data.data as TimeEntryConflictItem[];
}
